"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        position: 'relative',
        border: `1px solid ${theme.grey8}`,
        borderRadius: 10,
        backgroundColor: theme.white1,
        transition: '200ms ease-out',
        '&[data-drag-enter=true]': {
            border: `1px solid ${theme.indigo2}`
        }
    },
    dropzoneWrapper: {
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 20px',
        transition: '200ms ease-out',
        '&[data-drag-enter=true]': {
            opacity: 0.2
        },
        '&[data-is-responsive=true]': {
            padding: '15px 15px 0 15px'
        }
    },
    dropzoneBody: {
        display: 'flex',
        height: 290,
        '&[data-is-responsive=true]': {
            flexWrap: 'wrap',
            height: '100%'
        }
    },
    leftColumn: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 20em',
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
        '&[data-is-responsive=true]': {
            marginTop: 20,
            maxHeight: 185,
            order: 2,
            '&[data-is-disabled=true]': {
                marginTop: 0
            }
        }
    },
    rightColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flex: '2 2 20em',
        height: '100%',
        paddingLeft: 20,
        borderLeft: `1px solid ${theme.grey6}`,
        '&[data-is-responsive=true]': {
            paddingLeft: 0,
            borderLeft: 'none'
        }
    },
    rightColumnContent: {
        position: 'relative',
        zIndex: 2,
        minHeight: 'inherit',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 1,
        transition: 'opacity 200ms linear 100ms'
    },
    dropzoneLabel: {
        fontSize: 14,
        color: theme.grey1,
        marginBottom: 10,
        textAlign: 'center',
        '& p': {
            lineHeight: '18px'
        },
        '& p:first-child': {
            marginBottom: 10
        }
    },
    dropzoneIcon: {
        color: theme.indigo3,
        position: 'absolute',
        top: 'calc(50% - 14px)',
        left: 'calc(50% - 14px)',
        opacity: 0,
        transform: 'translateY(-28px)',
        transition: 'opacity 200ms linear, transform 0ms linear 300ms',
        '&[data-drag-enter=true]': {
            zIndex: 2,
            opacity: 1,
            transform: 'translateY(0)',
            transition: 'opacity 200ms linear 200ms, transform 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275) 200ms'
        }
    },
    fileSelectBtn: {
        color: theme.grey3,
        backgroundColor: 'transparent',
        border: `1px solid currentColor`,
        borderRadius: 4,
        padding: '7px 15px',
        fontWeight: 700,
        fontSize: 11,
        lineHeight: '14px',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        cursor: 'pointer',
        transition: 'color 100ms linear',
        marginBottom: 1,
        '&:focus': {
            outline: 'none',
            color: theme.indigo3
        },
        '&:hover': {
            color: theme.indigo3
        }
    },
    sizeWarning: {
        color: theme.grey4,
        fontSize: 12,
        letterSpacing: '0.24px',
        padding: '4px 0'
    }
});
//# sourceMappingURL=fileUpload.style.js.map